import * as React from 'react';
export default function useDelayReset(timeout = 10) {
    const [bool, setBool] = React.useState(false);
    const delayRef = React.useRef(null);
    const cancelLatest = () => {
        window.clearTimeout(delayRef.current);
    };
    React.useEffect(() => cancelLatest, []);
    const delaySetBool = (value, callback) => {
        cancelLatest();
        delayRef.current = window.setTimeout(() => {
            setBool(value);
            if (callback) {
                callback();
            }
        }, timeout);
    };
    return [bool, delaySetBool, cancelLatest];
}
